import { isToday, isTomorrow } from '@eversports/dates'

import type { Locale } from '../../localization/i18n'

import formatDate from './format-date'

interface Props {
  date: Date
  locale: Locale
  dateFormatOptions?: Intl.DateTimeFormatOptions
}

export default function formatRelativeTodayTomorrowDate({ date, locale, dateFormatOptions }: Props) {
  const rtf = new Intl.RelativeTimeFormat(locale, { style: 'long', numeric: 'auto' })

  if (isToday(date)) {
    return rtf.format(0, 'day')
  }

  if (isTomorrow(date)) {
    return rtf.format(1, 'day')
  }

  return formatDate({ date, locale, options: dateFormatOptions })
}
